import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getBatteryIds } from "./use-battery";
import { mergeArrays } from "../layout/utils/mergeArrays";

export function useBatteryOptions(driverId) {
  const { data, isLoading } = useQuery({
    queryKey: ["batteryIds", driverId],
    queryFn: () => getBatteryIds(driverId),
    enabled: !!driverId,
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const options = useMemo(
    () =>
      mergeArrays(data?.assignedBatteries ?? [], data?.allBatteries ?? []) ??
      [],
    [data],
  );

  return {
    options,
    assignedLength: data?.assignedBatteries?.length ?? 0,
    isLoading,
  };
}
